import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgSellIcon = function SvgSellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#828282",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 23.344C3 11.556 12.556 2 24.344 2S45.69 11.556 45.69 23.344c-.01 11.784-9.56 21.334-21.345 21.345C12.556 44.689 3 35.133 3 23.344M24.344 4.958a18.416 18.416 0 1 0 18.417 18.386C42.734 13.19 34.5 4.968 24.344 4.958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.788 20.15c.809-4.22 3.658-7.059 7.158-7.059a6.37 6.37 0 0 1 5.659 3.254l-2.297 2.248a3.94 3.94 0 0 0-3.342-2.07 3.22 3.22 0 0 0-2.81 1.557 4.7 4.7 0 0 0-.73 2.07h7.079l-.483 1.972h-7.01a6 6 0 0 0-.069.858q-.015.256 0 .512h6.744l-.474 2.17H21.23c.059.736.274 1.452.631 2.1a4.01 4.01 0 0 0 3.421 1.971 3.57 3.57 0 0 0 2.86-1.489l1.97 2.662a6.9 6.9 0 0 1-10.745-.73 10.4 10.4 0 0 1-1.627-4.515h-1.666l.483-2.1h.986a6 6 0 0 1 0-.562 6 6 0 0 1 0-.808h-1.47l.484-1.972z"
  })));
};

export { SvgSellIcon as default };
